<template>
    <div>
        <b-col cols="12 mb-2" v-if="indumentariasElegidas?.length > 0">
            <b>Observaciones de las indumentarias:</b> {{ item.observacion_indumentarias }}
        </b-col>
        <div>
            <div>
                <table class="table tabla-resumen table-bordered mb-0 h-100">
                    <tr class="lightgray-content">
                        <th></th>
                        <th>Pedido</th>
                        <th class="price">Precio</th>
                    </tr>

                    <tr>
                        <td class="h1 text-center regular">1</td>
                        <td>
                            <strong class="text-bold h5 d-block mb-1">{{ item.titulo }}</strong>
                            <template v-if="item.name">
                                <strong class="text-bold h7 d-block mb-1">{{ item.name }}</strong>
                            </template>
                        </td>
                        <td>
                            <template v-if="item.activar_pago_plazos && plazos">
                                <del class="h5 m-0">
                                    {{ categoria.precio | formatear_precio }}
                                </del>
                                <h3>{{ plazos[0].importe | formatear_precio }}</h3>
                            </template>
                            <div class="h3 m-0" v-else>
                                <div v-if="base.descuento_aplicado > 0 || base.descuento_integro > 0">
                                    <del class="total-price h5 m-0">{{ base.categoria_base.precio | formatear_precio }}</del>
                                    <span class="total-price h5">
                                        <template v-if="base.descuento_aplicado > 0">(-{{ base.descuento_aplicado }}%)</template>
                                        <template v-else-if="base.descuento_integro > 0">(-{{ base.descuento_integro | formatear_precio }})</template>
                                    </span>
                                </div>
                                {{ precioCategoriaConDescuento | formatear_precio }}
                            </div>

                        </td>
                    </tr>

                    <template v-if="indumentariasElegidas?.length > 0">
                        <tr v-for="(indumentaria, index) in indumentariasElegidas" :key="index + '-' + indumentaria.id">
                            <td class="text-center">
                                <img :src="indumentaria.imagen" style="width: 50px;" alt=""/>
                            </td>
                            <td>
                                <strong class="text-bold h5 d-block mb-1">
                                    {{ indumentaria.nombre }}
                                    <small style="font-size: 11px;">
                                        ({{ indumentaria.unidades }} {{ indumentaria.unidades > 1 ? 'unidades' : 'unidad'}})
                                    </small>
                                </strong>
                                <small>
                                    <strong class="text-bold h7 d-block mb-1">Talla {{ indumentaria.talla.nombre }}</strong>
                                </small>
                            </td>
                            <td>
                                <div class="h3 m-0" v-if="indumentaria.incluida && indumentaria.unidades === 1">
                                    {{ '0' | formatear_precio }}
                                </div>
                                <div class="h3 m-0" v-else>
                                    {{ indumentaria.precio_total | formatear_precio }}
                                </div>
                            </td>
                        </tr>
                    </template>
                    <tr>
                        <td colspan="2" style="text-align: right">
                            <span class="total-price h2 m-0">TOTAL: </span>
                        </td>
                        <td>
                            <span class="total-price h2 m-0">{{ totalFinal | formatear_precio }}<small>*</small></span>
                            <div class="mt-2" v-if="(base.descuento_aplicado > 0 || base.descuento_integro > 0) && indumentariasElegidas?.length > 0">
                                <i class="fas fa-info-circle mr-1"></i>
                                <span>El descuento <strong>no se aplica a las indumentarias</strong>.</span>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
            <div>
                <template v-if="item.activar_pago_plazos && plazos">
                    <table class="table tabla-resumen table-bordered">
                        <tr>
                            <th class="p-0 pt-1" colspan="3"><h3 class="text-center">{{ $t('bases.plazos') }}</h3></th>
                        </tr>
                        <tr class="lightgray-content">
                            <th></th>
                            <th>{{ $t('bases.fecha') }}</th>
                            <th>{{ $t('bases.importe') }}</th>
                        </tr>
                        <template v-for="(plazo, index) in plazos">
                            <tr :key="index">
                                <td class="pt-2 pb-0 text-center"><h5>{{ plazo.id }}</h5></td>
                                <td class="pt-2 pb-0"><h5>{{ plazo.fecha }}</h5></td>
                                <td class="pt-2 pb-0"><h5>{{ !plazo.price_management_interno ? ($t('bases.importe_plazo', { importe_sin_gd: $n(plazo.importe, "currency"), gd: $n(plazo.price_management, "currency" ) })) : ($n(plazo.importe, "currency")) }}</h5></td>
                            </tr>
                        </template>
                    </table>
                    <div v-if="item.activar_pago_plazos && plazos" class="border p-2">
                        <b><p class="m-0">{{ $t('bases.info_plazos') }}</p></b>
                    </div>
                </template>
            </div>
        </div>
        <b-col v-if="item.activar_pago_plazos" cols="12" class="mt-3 mb-3">
            <AddPlazosComponent
                :frecuencias="item.frecuencias"
                :min_plazos="item.min_cantidad_plazos"
                :max_plazos="item.max_cantidad_plazos"
                :gastos="item.price_management_online"
                :tiene_gastos="item.price_management_interno_taquilla ? false : true"
                :disabled="loading_plazos"
                :esMovil="esMovil"
                @terminado="calcularPlazos"
                @reset="pagarImporteCompleto"
            />
        </b-col>
    </div>
</template>

<script>
    import AddPlazosComponent from '@/components/frontend/compra/plazos/AddPlazosComponent.vue';
    export default {
        components: { AddPlazosComponent,  },
        props: ["base", "categoria", "indumentariasElegidas", "esMovil"],
        data() {
            return {
                gd_taquilla: this.$store.getters.getGd['venta_bases_fisica'],
                item: { ...this.categoria },
                plazos: null,
                loading_plazos: false,
            };
        },
        computed: {
            totalFinal() {
                let basePrecio = parseFloat(this.item.precio);

                if (this.base.descuento_aplicado > 0) {
                    basePrecio = basePrecio - (basePrecio * this.base.descuento_aplicado / 100);
                } else if (this.base.descuento_integro > 0) {
                    basePrecio = basePrecio - this.base.descuento_integro;
                }

                if (this.plazos && this.plazos.length > 0){
                    basePrecio = this.plazos[0].importe;
                }

                let total = basePrecio;


                if (this.gd_taquilla) {
                    if (!this.gd_taquilla.modalidad) {
                        total += this.gd_taquilla.cantidad;
                    } else {
                        total += (parseFloat(this.item.precio) * this.gd_taquilla.cantidad / 100);
                    }
                }

                if (this.indumentariasElegidas?.length > 0) {
                    total += this.totalIndumentarias;
                }

                this.$emit('setTotal', total);
                return total;
            },
            totalIndumentarias() {
                let total = 0;
                for (let i in this.indumentariasElegidas) {
                    if (this.indumentariasElegidas[i].incluida && this.indumentariasElegidas[i].unidades == 1) {
                        total = total + 0;
                    } else {
                        total = total + parseFloat(this.indumentariasElegidas[i].precio_total);
                    }
                }
                return total;
            },
            totalConIndumentarias() {
                let total = this.plazos && this.plazos.length > 0 ? this.plazos[0].importe : this.item.precio;
                if (this.indumentariasElegidas?.length > 0) {
                    total += this.totalIndumentarias;
                }
                return total;
            },
            totalSinDescuento() {
                let total = parseFloat(this.item.precio);

                if (this.gd_taquilla) {
                    if (!this.gd_taquilla.modalidad) {
                        total += this.gd_taquilla.cantidad;
                    } else {
                        total += (parseFloat(this.item.precio) * this.gd_taquilla.cantidad / 100);
                    }
                }

                if (this.indumentariasElegidas?.length > 0) {
                    for (let item of this.indumentariasElegidas) {
                        if (!(item.incluida && item.unidades === 1)) {
                            total += parseFloat(item.precio_total);
                        }
                    }
                }

                return total;
            },
            precioCategoriaConDescuento() {
                let precio = parseFloat(this.item.precio);
                if (this.base.descuento_aplicado > 0) {
                    precio = precio - (precio * this.base.descuento_aplicado / 100);
                } else if (this.base.descuento_integro > 0) {
                    precio = precio - this.base.descuento_integro;
                }
                return precio;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            }

        },
        methods: {
            calcularPlazos(data) {
                this.loading_plazos = true;

                if (this.indumentariasElegidas?.length > 0) {
                    this.item.importe_total = this.item.price_management_interno_taquilla == 0
                        ? this.totalConIndumentarias - this.item.price_management_taquilla
                        : this.totalConIndumentarias;
                }
                this.item.plazoSelect = data.plazoSelect;
                this.item.frecuenciaSelect = data.frecuenciaSelect;

                const params = {
                    lista_id: this.base.lista_id,
                    categoria_id: this.item.id,
                    frecuencia_id: data.frecuenciaSelect?.id,
                    n_plazos: data.plazoSelect,
                    session_id: this.item.session_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.bases.calcular-plazos'), params).then(res => {
                    this.plazos = res.data.plazos;
                }).finally(() => {
                    this.loading_plazos = false;
                    this.closeModalPlazos('pago-plazos-bases');
                });
            },
            pagarImporteCompleto() {
                this.loading_plazos = true;

                const params = {
                    filters: { tid: this.configuracion.hash_teatro },
                    lista_id: this.base.lista_id,
                    session_id: this.item.session_id
                };
                this.$store.dispatch(this.config.getVuexAlias('back.bases.borrar-plazos'), params).then(res => {
                    this.plazos = null;
                    this.item.frecuenciaSelect = null;
                    this.item.plazoSelect = null;
                    this.item.precio = this.categoria.precio;
                }).finally(() => {
                    this.loading_plazos = false;
                });
            },
            showModalPlazos(modal) {
                this.$modal.show(modal);
            },
            closeModalPlazos(modal) {
                this.$modal.hide(modal);
            },

        }
    };
</script>
